module.exports = __webpack_public_path__ + "img/83.4.NH3-N.0e042433.png";